import { Component } from './live-codec.js';

export class SpectatorCamera {
    constructor() { this.key = null; }
    cycle(view, scene, direction) {
        const players = [...(scene?.entities.values() ?? [])].filter(entity => {
            const player = entity.state.components[Component.Player];
            return player && (player.state & 1) && player.team >= 2 && entity.state.components[Component.Transform];
        }).sort((a, b) => a.state.index - b.state.index);
        if (!players.length) { this.key = null; return false; }
        const current = players.findIndex(entity => entity.key === this.key);
        const entity = players[current < 0 ? (direction > 0 ? 0 : players.length - 1) : (current + direction + players.length) % players.length];
        this.key = entity.key;
        const transform = entity.state.components[Component.Transform];
        entity.object.getWorldPosition(view.camera.position);
        const player = entity.state.components[Component.Player];
        view.camera.position.z += player.state & 4 ? 45 : player.playerClass === 1 ? 65 : 68;
        view.yaw = (entity.state.components[Component.Player].eyeAngles?.[1] ?? transform.angles[1]) * Math.PI / 180;
        const pitch = entity.state.components[Component.Player].eyeAngles?.[0] ?? transform.angles[0];
        view.pitch = -(((pitch + 180) % 360 + 360) % 360 - 180) * Math.PI / 180;
        view.keys.clear();
        return true;
    }
}
